import Image from 'next/image';
import styled from 'styled-components';
import PageHero from '../../layouts/PageHero';
import SearchCity from '../Searchbar/searchCity';
import CitiesModal from '../CitiesModal.tsx';

const AdventureStyle = styled.div`
  background-image: url('https://res.cloudinary.com/see-sight-tours/image/upload/v1684309302/Rectangle_117_ssshmm.svg');
`;
const Adventure = () => {
  return (
    <div className="relative w-full h-[250px] md:h-[45vh]">
      <Image
        src={
          'https://res.cloudinary.com/see-sight-tours/image/upload/v1684309302/Rectangle_117_ssshmm.svg'
        }
        alt="adventure section background"
        width={24}
        height={24}
        className="w-full h-full object-cover"
        loading="lazy"
      />

      <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4">
        <div className="text-white text-center max-w-[88%]">
          <h2 className=" text-[18px] sm:text-2xl lg:text-4xl font-semibold ">
            Ready For An Adventure?
          </h2>
          <p className="text-[14px] sm:text-[18px] lg:text-[28px] font-[400]">
            The best small group tours operating across Canada and the United
            States
          </p>
        </div>
        <div className="relative mt-20 w-full">
          <CitiesModal />
        </div>
      </div>
    </div>
  );
};

export default Adventure;
